import styles from "./FillButton.module.css";

function FillButton({ leftIcon, text, onClick, className, disabled }) {
  return (
    <button className={`${styles.button} ${className} ${disabled ? styles.disabled : ""}`} onClick={onClick}>
      {leftIcon && leftIcon}
      <span
        style={{
          paddingLeft: `${leftIcon ? "4px" : ""}`,
        }}
      >
        {text}
      </span>
    </button>
  );
}

export default FillButton;
